import { mmvContractDetailsDataLabelsMap } from 'mmv/inquiry/steps/contractDetails/labels';
import { LabelsMap } from 'new/form/common/types';

import { mmvCustomerDataLabelsMap } from '../inquiry/steps/customerData/labels';

export const mmvLabels: LabelsMap = {
  ...mmvContractDetailsDataLabelsMap,
  ...mmvCustomerDataLabelsMap,
};
